import { takeLatest, put } from "redux-saga/effects";
import Actions from "../action";
import { doGet, doPost } from "../../service/index";
import END_POINTS from "./EndPoints";
import {
    ACCESS_CONTROL_SUPERVISORS,
    ACCESS_CONTROL_ADD_HOSTEL,
    ACCESS_CONTROL_REMOVE_HOSTEL,
    ACCESS_CONTROL_SUGGESTIONS,
} from "../action/AccessControlAction";

export function* accessControlSupervisorListSaga({ params, callback }) {
    try {
        const response = yield doGet(END_POINTS.ACCESS_CONTROL_SUPERVISORS, params);
        yield put(Actions.accessControlSupervisorListSuccess(response));
        if (callback) callback(response);
    } catch (error) {
        yield put(Actions.accessControlSupervisorListFailure({ error }));
        if (callback) callback(error);
    }
}

export function* accessControlAddHostelSaga({ params, callback }) {
    try {
        const response = yield doPost(END_POINTS.ACCESS_CONTROL_ADD_HOSTEL, params);
        yield put(Actions.accessControlAddHostelSuccess(response));
        if (callback) callback(response);
    } catch (error) {
        yield put(Actions.accessControlAddHostelFailure({ error }));
        if (callback) callback(error);
    }
}

export function* accessControlRemoveHostelSaga({ params, callback }) {
    try {
        const response = yield doPost(END_POINTS.ACCESS_CONTROL_REMOVE_HOSTEL, params);
        yield put(Actions.accessControlRemoveHostelSuccess(response));
        if (callback) callback(response);
    } catch (error) {
        yield put(Actions.accessControlRemoveHostelFailure({ error }));
        if (callback) callback(error);
    }
}

export function* accessControlSuggestionsSaga({ params, callback }) {
    try {
        const response = yield doGet(END_POINTS.ACCESS_CONTROL_SUPERVISORS, params);
        yield put(Actions.accessControlSuggestionsSuccess(response));
        if (callback) callback(response);
    } catch (error) {
        yield put(Actions.accessControlSuggestionsClear());
        if (callback) callback(error);
    }
}

export default function* accessControlWatcher() {
    yield takeLatest(ACCESS_CONTROL_SUPERVISORS, accessControlSupervisorListSaga);
    yield takeLatest(ACCESS_CONTROL_ADD_HOSTEL, accessControlAddHostelSaga);
    yield takeLatest(ACCESS_CONTROL_REMOVE_HOSTEL, accessControlRemoveHostelSaga);
    yield takeLatest(ACCESS_CONTROL_SUGGESTIONS, accessControlSuggestionsSaga);
}
